/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Roles_Primary_BadgeInputs */

const cs_clients_roles_primary_badge = /** @type {(inputs: Clients_Roles_Primary_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primární`)
};

const en_clients_roles_primary_badge = /** @type {(inputs: Clients_Roles_Primary_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Clients_Roles_Primary_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_roles_primary_badge = /** @type {((inputs?: Clients_Roles_Primary_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Roles_Primary_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_roles_primary_badge(inputs)
	return cs_clients_roles_primary_badge(inputs)
});